import React, { useRef } from 'react';

export const Swiper = ({options}) => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
     <div className="mb-4 pb-px relative">
      {/* Navigation buttons (optional) */}
      <button 
        onClick={scrollLeft}
        className="absolute size-[40px] -left-5 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full font-bold p-2 hover:!bg-black hover:!text-white transition-colors"
      >
        ←
      </button>
      <button 
        onClick={scrollRight}
        className="absolute size-[40px] -right-5 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full  font-bold p-2 hover:!bg-black hover:!text-white transition-colors"
      >
        →
      </button>

      {/* Scrollable container */}
      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth py-2"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {options.map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0 aspect-[1/1] flex flex-col items-center justify-center py-1  px-2 bg-white rounded-lg  hover:scale-115 shadow-md transition-shadow cursor-pointer
                       min-[0px]:w-[calc((100vw-5rem)/3)] min-[0px]:max-w-24
                       md:w-[calc((100vw-7rem)/6.5)] md:max-w-28"
          >
            <img  
              src={item.icon} 
              alt={item.label}
              className="size-[35px] mb-2 object-contain"
            />
            <p className="text-xs font-bold  text-center text-gray-700 leading-tight">
              {item.label}
            </p>
          </div>
        ))}
      </div>

      {/* Hide scrollbar with CSS */}
      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  )
}

